import * as swcHelpers from '@swc/helpers';
import React__default, { forwardRef } from 'react';
import classnames from 'classnames';
import { useIntl } from '@grandvisionhq/state';
import Price from '../Price/Price.js';

const priceBaseClassName = 'elements-line-item-aside__price';
const LineItemAside = /*#__PURE__*/ forwardRef((_param, ref)=>{
    var { children , className , currency , discountPrice , price  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "children",
        "className",
        "currency",
        "discountPrice",
        "price"
    ]);
    const { getLabel  } = useIntl();
    let content = children;
    if (discountPrice === 0) {
        content = /*#__PURE__*/ React__default.createElement("p", {
            className: `${priceBaseClassName} ${priceBaseClassName}--free`
        }, /*#__PURE__*/ React__default.createElement("span", {
            className: "price"
        }, getLabel('products.freeProduct')));
    } else if (!children && price) {
        const classNames = classnames(priceBaseClassName, {
            [`${priceBaseClassName}--strikethrough`]: typeof discountPrice === 'number'
        });
        content = /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement("p", {
            className: classNames
        }, /*#__PURE__*/ React__default.createElement(Price, {
            value: price,
            currency: currency
        })), discountPrice && /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, "\xa0", /*#__PURE__*/ React__default.createElement("p", {
            className: priceBaseClassName
        }, /*#__PURE__*/ React__default.createElement(Price, {
            value: discountPrice,
            currency: currency,
            type: "discount"
        }))));
    }
    return /*#__PURE__*/ React__default.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('elements-line-item-aside', className),
        ref: ref
    }), content);
});
LineItemAside.displayName = 'LineItemAside';
var LineItemAside$1 = LineItemAside;

export { LineItemAside$1 as default };
//# sourceMappingURL=LineItemAside.js.map
